// extracted by mini-css-extract-plugin
export var center = "_3p-2";
export var clickableRow = "_3p-5";
export var expandedRow = "_3p-7";
export var hoverable = "_3p-4";
export var left = "_3p-1";
export var right = "_3p-3";
export var row = "_3p-0";
export var selectedRow = "_3p-6";
export var summaryRow = "_3p-8";